module.exports = __webpack_public_path__ + "images/help-videos-preview-cal-986e833f24803b3566aba3919ea169f4.png";